import React from 'react';
import { Box, Typography } from '@mui/material';
import { Controller } from 'react-hook-form';

import Input from '../../../common/form/Input';
import MaskInput from '../../../common/form/MaskInput';
import Button from '../../../common/buttons/Button';
import RadioButtons from '../../../common/buttons/RadioButtons';
import Checkbox from '../../../common/form/Checkbox';
import { FormValues } from './types';

interface RepresentationStepProps {
	formValues: FormValues;
	setValue: any;
	control: any;
	errors: any;
	isRequired?: boolean;
}

export default function RepresentationStep({
	formValues,
	setValue,
	control,
	errors,
	isRequired = true,
}: RepresentationStepProps) {
	return (
		<Box sx={{ py: 2 }}>
			{/* Agent/Management */}
			<Typography variant="h6" sx={{ mb: 2, color: 'text.label' }}>
				Agent/Management
			</Typography>

			<Box sx={{ mb: 3 }}>
				<Controller
					name="hasRepresentation"
					control={control}
					render={({ field }) => (
						<Checkbox
							items={[
								{
									id: 'no_representation',
									name: 'I do not currently have an agent or representation',
									checked: field.value === false,
									handleOnChange: (event) => {
										field.onChange(!event.target.checked);
										// Clear representation fields when checkbox is checked
										if (event.target.checked) {
											setValue(
												'representativeFullName',
												'',
												{
													shouldDirty: true,
												}
											);
											setValue(
												'representativeCompany',
												'',
												{
													shouldDirty: true,
												}
											);
											setValue(
												'representativePhone',
												'',
												{
													shouldDirty: true,
												}
											);
											setValue(
												'representativeEmail',
												'',
												{
													shouldDirty: true,
												}
											);
											setValue(
												'billThroughAgentCompany',
												'',
												{
													shouldDirty: true,
												}
											);
										}
									},
								},
							]}
						/>
					)}
				/>
			</Box>

			{(formValues.hasRepresentation ||
				formValues.hasRepresentation === undefined) && (
				<>
					<Box sx={{ display: 'flex', gap: 3, mb: 3 }}>
						<Controller
							name="representativeFullName"
							control={control}
							render={({ field }) => (
								<Input
									{...field}
									label="Agent or Representative full name"
									required
									fullWidth
								/>
							)}
						/>
						<Controller
							name="representativeCompany"
							control={control}
							render={({ field }) => (
								<Input
									{...field}
									label="Agent or Representative company"
									required
									fullWidth
								/>
							)}
						/>
					</Box>

					<Box sx={{ display: 'flex', gap: 3, mb: 3 }}>
						<MaskInput
							id="representativePhone"
							name="representativePhone"
							label="Agent or Representative Phone Number"
							value={formValues.representativePhone}
							onChange={(e) =>
								setValue(
									'representativePhone',
									e.target.value,
									{
										shouldDirty: true,
									}
								)
							}
							mask="phone"
							required
							fullWidth
						/>
						<Controller
							name="representativeEmail"
							control={control}
							render={({ field }) => (
								<Input
									{...field}
									label="Agent or Representative email"
									required
									fullWidth
								/>
							)}
						/>
					</Box>

					<Box sx={{ mb: 3 }}>
						<Controller
							name="billThroughAgentCompany"
							control={control}
							render={({ field }) => (
								<RadioButtons
									label="Do you bill through agent/rep company?"
									name="billThroughAgentCompany"
									options={[
										{
											value: 'yes',
											label: 'Yes',
										},
										{
											value: 'no',
											label: 'No',
										},
									]}
									value={field.value}
									onChange={field.onChange}
								/>
							)}
						/>
					</Box>
				</>
			)}

			<Box sx={{ mb: 4 }}>
				<Typography
					variant="body2"
					sx={{ color: 'text.secondary', mb: 1 }}
				>
					Information about Orbito's privacy policy and information
					sharing can be found below.
				</Typography>
				<Button
					variant="text"
					color="primary"
					onClick={() => {
						// TODO: Implement privacy policy modal or navigation
						console.log('View privacy policy clicked');
					}}
					sx={{ p: 0, textDecoration: 'underline' }}
				>
					VIEW PRIVACY POLICY
				</Button>
			</Box>
		</Box>
	);
}
